import React from "react";
import { IoInformationCircleOutline } from "react-icons/io5";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "100%",
  },
});
// `maxWidth` caps the bubble for long copy; omitted, it keeps the original
// full-width behaviour other callers rely on.
const HoverInfoLogo = ({ title, placement, maxWidth }) => {
  return (
    <CustomWidthTooltip
      title={title}
      arrow
      placement={placement ? placement : "bottom-end"}
      // Touch: open on a tap (default needs a ~700ms long-press) and stay
      // readable for a few seconds after the finger lifts.
      enterTouchDelay={0}
      leaveTouchDelay={4000}
      componentsProps={{
        tooltip: {
          sx: {
            // width:"40%",
            // !important: the styled popper's maxWidth: 100% is more specific.
            ...(maxWidth
              ? {
                  maxWidth: `${
                    typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth
                  } !important`,
                }
              : {}),
            backgroundColor: "#F5F5F5",
            color: "#000", // Text color
            fontSize: "0.875rem", // Adjust font size
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Optional shadow
            border: "1px solid #ddd", // Optional border for clarity
          },
        },
        arrow: {
          sx: {
            color: "#F5F5F5", // Matches the tooltip background
          },
        },
      }}
      slots={{
        transition: Zoom,
      }}
    >
      <div
        className="ms-2"
        style={{ display: "inline-block", touchAction: "manipulation" }}
        tabIndex={0}
        aria-label={typeof title === "string" ? title : "More info"}
      >
        <IoInformationCircleOutline
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
          }}
        />
      </div>
    </CustomWidthTooltip>
  );
};

export default HoverInfoLogo;
